import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { merge } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import {
  onWebsocketMessageDispatchUpdateEntities,
  onWebsocketMessageDispatchAddRemoveEntities,
  getSubscriptionNameForFeature
} from '@zerops/zef/entities';
import { onWebsocketSubscriptionName } from '@zerops/zef/websocket';
import { UserEntity } from '@zerops/zerops/core/user-base';
import { availableAddons } from '@zerops/zerops/core/billing-base';
import { SubscriptionEntity } from './subscription.entity';

@Injectable()
export class SubscriptionBaseEffect {

  setupListStreamSubscription$ = createEffect(() => this._userEntity.activeClientId$.pipe(
    map((clientId) => this._subscriptionEntity.listSubscribe(
      clientId,
      undefined,
      {
        search: [
          {
            name: 'status',
            operator: 'eq',
            value: 'ACTIVE'
          }
        ]
      }
    ))
  ));

  setupAddRemoveMessage$ = createEffect(() => this._actions$.pipe(
    onWebsocketMessageDispatchAddRemoveEntities(this._subscriptionEntity)
  ));

  setupUpdateStreamSubscription$ = createEffect(() => this._userEntity.activeClientId$.pipe(
    map((clientId) => this._subscriptionEntity.updateSubscribe(clientId))
  ));

  onUpdateStreamMessage$ = createEffect(() => this._actions$.pipe(
    onWebsocketMessageDispatchUpdateEntities(this._subscriptionEntity)
  ));

  // IPv4 request and release processes change subscriptions only after their PUT returns.
  onSubscriptionMessageLoadAvailableAddons$ = createEffect(() => merge(
    this._actions$.pipe(onWebsocketSubscriptionName(getSubscriptionNameForFeature(this._subscriptionEntity.entityName, 'list'))),
    this._actions$.pipe(onWebsocketSubscriptionName(getSubscriptionNameForFeature(this._subscriptionEntity.entityName, 'update')))
  ).pipe(
    debounceTime(500),
    map(() => availableAddons())
  ));

  constructor(
    private _actions$: Actions,
    private _subscriptionEntity: SubscriptionEntity,
    private _userEntity: UserEntity
  ) {}
}
